const COMMENT_STATUS = {
  ACTIVE: 'active',
  RESOLVED: 'resolved',
};

export { COMMENT_STATUS };
